fa-icon{color:#ce2d44}.toolbar-button fa-icon{position:absolute;color:#ce2d44;display:inline-block;margin-left:-5px;padding-top:3px}
/*# sourceMappingURL=show-feedback-button.component.css.map */
